module.exports = __webpack_public_path__ + "delivered_icon.png";